export default "__VITE_ASSET__CfKmMcqf__"